/**
 * BrewNectar cart subscription plan changer
 * Updates selling_plan via /cart/change.js and refreshes drawer/page sections.
 * Also strips RecurPay’s default Change Plan widgets.
 */
(function () {
  const PLAN_INPUT = '[data-bn-cart-plan-input]';
  const PLAN_ROOT = '[data-bn-cart-plan]';

  function routes() {
    return window.routes || {};
  }

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  function stripRecurpayWidgets(root) {
    const scope =
      root ||
      document.querySelector('cart-drawer.bn-drawer') ||
      document.querySelector('main#MainContent[data-template="cart"]');

    if (!scope) return;

    const selectors = [
      '.upgrade-subscription-cart',
      '.upgrade-icon-wrapper.upgrade-select-box',
      '.upgrade-select-box',
      '.cart-plan-dropdown-wrapper',
      '.cart-plan-dropdown',
      '.cart-plan-dropdown-title',
      '.cart-plan-saving-wrapper',
      '.cart-plan-saving-img',
      '.cart-plan-saving-text',
      '.recurpay__widget',
      '.recurpay-widget',
      '.recurpay_widget',
      '[class*="recurpay__"]',
      '[class*="recurpay-"]',
      '[id*="recurpay"]',
      '[class*="Recurpay"]',
      '[class*="rp-cart"]',
      '[class*="RpCart"]',
    ];

    selectors.forEach((selector) => {
      scope.querySelectorAll(selector).forEach((el) => {
        if (el.closest(PLAN_ROOT)) return;
        const outer = el.closest('.upgrade-subscription-cart') || el;
        if (outer.closest(PLAN_ROOT)) return;
        outer.remove();
      });
    });
  }

  window.bnStripRecurpayCartWidgets = stripRecurpayWidgets;

  function sectionPayload() {
    const sections = [];
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      sections.push('cart-drawer');
      sections.push('cart-icon-bubble');
    }

    const mainItems = document.getElementById('main-cart-items');
    if (mainItems?.dataset.id) sections.push(mainItems.dataset.id);

    const mainFooter = document.getElementById('main-cart-footer');
    if (mainFooter?.dataset.id) sections.push(mainFooter.dataset.id);

    return [...new Set(sections)];
  }

  function getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function paintSections(parsedState) {
    if (!parsedState?.sections) return;

    const drawer = document.querySelector('cart-drawer');
    if (drawer && parsedState.sections['cart-drawer']) {
      const drawerInner = drawer.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.innerHTML = getSectionInnerHTML(parsedState.sections['cart-drawer'], '.drawer__inner');
      }
      drawer.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    const icon = document.getElementById('cart-icon-bubble');
    if (icon && parsedState.sections['cart-icon-bubble']) {
      icon.innerHTML = getSectionInnerHTML(parsedState.sections['cart-icon-bubble'], '.shopify-section');
    }

    const mainItems = document.getElementById('main-cart-items');
    if (mainItems?.dataset.id && parsedState.sections[mainItems.dataset.id]) {
      const target = mainItems.querySelector('.js-contents') || mainItems;
      target.innerHTML = getSectionInnerHTML(
        parsedState.sections[mainItems.dataset.id],
        '.js-contents'
      );
      document.querySelector('cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    const mainFooter = document.getElementById('main-cart-footer');
    if (mainFooter?.dataset.id && parsedState.sections[mainFooter.dataset.id]) {
      const target = mainFooter.querySelector('.js-contents') || mainFooter;
      const html = getSectionInnerHTML(parsedState.sections[mainFooter.dataset.id], '.js-contents');
      if (html) target.innerHTML = html;
      mainFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }
  }

  function setLoading(root, loading) {
    if (!root) return;
    root.classList.toggle('is-loading', loading);
    root.querySelectorAll(PLAN_INPUT).forEach((input) => {
      input.disabled = loading;
    });
  }

  function syncSelectedUI(root, selectedValue) {
    const select = root.querySelector(PLAN_INPUT);
    if (select && String(select.value) !== String(selectedValue)) {
      select.value = String(selectedValue);
    }
  }

  async function changePlan(root, sellingPlanId) {
    const lineKey = root.dataset.lineKey;
    const quantity = parseInt(root.dataset.quantity, 10) || 1;
    const changeUrl = routes().cart_change_url || '/cart/change.js';

    if (!lineKey) return;

    setLoading(root, true);
    syncSelectedUI(root, sellingPlanId);

    const body = {
      id: lineKey,
      quantity,
      selling_plan: sellingPlanId ? String(sellingPlanId) : null,
      sections: sectionPayload(),
      sections_url: window.location.pathname,
    };

    try {
      const response = await fetch(changeUrl, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });
      const parsedState = await response.json();

      if (parsedState.errors) {
        console.error('[bn-cart-plan]', parsedState.errors);
        setLoading(root, false);
        // Revert select to previous plan
        const previous = root.dataset.currentPlan || '';
        syncSelectedUI(root, previous);
        return;
      }

      paintSections(parsedState);
      stripRecurpayWidgets();
      root.dataset.currentPlan = String(sellingPlanId || '');
      delete root.dataset.pendingPlan;

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bn-cart-plan',
          cartData: parsedState,
          variantId: root.dataset.variantId,
        });
      }
    } catch (error) {
      console.error('[bn-cart-plan]', error);
      setLoading(root, false);
      const previous = root.dataset.currentPlan || '';
      syncSelectedUI(root, previous);
    }
  }

  function onChange(event) {
    const input = event.target.closest?.(PLAN_INPUT) || (event.target.matches?.(PLAN_INPUT) ? event.target : null);
    if (!input) return;

    event.stopPropagation();
    const root = input.closest(PLAN_ROOT);
    if (!root || root.classList.contains('is-loading')) return;

    const nextValue = String(input.value || '');
    const previous = String(root.dataset.currentPlan || '');
    if (nextValue === previous) return;
    if (!nextValue) return;

    root.dataset.pendingPlan = nextValue;
    changePlan(root, nextValue);
  }

  function initRoots(scope) {
    (scope || document).querySelectorAll(PLAN_ROOT).forEach((root) => {
      const select = root.querySelector(PLAN_INPUT);
      if (select?.value) root.dataset.currentPlan = select.value;
    });
    stripRecurpayWidgets(scope);
  }

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.matches?.(PLAN_INPUT)) onChange(event);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest?.(PLAN_ROOT)) event.stopPropagation();
    },
    true
  );

  let stripTimer = null;
  function stripSoon(scope) {
    if (stripTimer) clearTimeout(stripTimer);
    stripTimer = setTimeout(() => {
      stripTimer = null;
      stripRecurpayWidgets(scope);
      initRoots(scope || document);
    }, 50);
  }

  // Only watch cart surfaces — never document.body (that lagged drawer paint)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (
          node.matches?.(
            '.upgrade-subscription-cart, .cart-plan-dropdown-wrapper, .cart-plan-saving-wrapper, [class*="recurpay"], [id*="recurpay"]'
          ) ||
          node.querySelector?.(
            '.upgrade-subscription-cart, .cart-plan-dropdown-wrapper, .cart-plan-saving-wrapper, [class*="recurpay"]'
          )
        ) {
          stripSoon(node.closest('cart-drawer') || node.closest('main#MainContent') || undefined);
          return;
        }
      }
    }
  });

  function start() {
    initRoots(document);
    stripRecurpayWidgets();

    const watchTargets = [
      document.querySelector('cart-drawer'),
      document.querySelector('main#MainContent[data-template="cart"]'),
    ].filter(Boolean);

    watchTargets.forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('cart:updated', () => {
    stripSoon();
  });
})();
